// eslint-disable-next-line import/prefer-default-export
export const getPersonalisationState = (state) => state.personalisation;
export const getBannerGalleryState = (state) => state.bannerGallery;
